/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Interrupted_BodyInputs */



/**
* | output |
* | --- |
* | "The page was reloaded or the device went to sleep. Everything recorded so far is kept." |
*
* @param {Meeting_Offline_Interrupted_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_interrupted_body = /** @type {((inputs?: Meeting_Offline_Interrupted_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Interrupted_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De pagina is herladen of het toestel viel in slaap. Wat al opgenomen is, blijft bewaard.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La page a été rechargée ou l'appareil s'est mis en veille. Tout ce qui est déjà enregistré est conservé.")
	return /** @type {LocalizedString} */ ("The page was reloaded or the device went to sleep. Everything recorded so far is kept.")
});